import { VerifyCodeLinkedinMeta, VerifyCodeLinkedinPayload } from 'types/store/VerifyCodeLinkedin';
import { createAsyncReducer } from 'utils/Redux';

import { verifyCodeLinkedinActions } from '../actions';

export default createAsyncReducer<VerifyCodeLinkedinMeta, VerifyCodeLinkedinPayload>(verifyCodeLinkedinActions);
